module.exports = __webpack_public_path__ + "static/img/072.994d8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/072.png
// module id = RNBJ
// module chunks = 0